import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap'

import './FilterUniverse.scss'

class FilterUniverse extends PureComponent {
  static propTypes = {
    value: PropTypes.any,
    choices: PropTypes.array,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    choices: [],
  }

  state = {
    showDrop: false,
  }

  onChange = (choice) => {
    this.props.onChange(choice.value)
  }

  dropDown = () => {
    this.setState({showDrop: !this.state.showDrop})
  }

  getSelectedChoice = () => {
    const value = parseInt(this.props.value, 10)
    return this.props.choices.find((choice) => choice.value === value) ?? null
  }

  render() {
    const selectedChoice = this.getSelectedChoice()

    return (
      <div className="filter filter-universe">
        <Dropdown
          isOpen={this.state.showDrop}
          toggle={() => this.dropDown()}>
          <DropdownToggle caret className={selectedChoice ? 'btn-color' : 'btn-transparent'}>
            {selectedChoice ? selectedChoice.text : 'Univers'}
          </DropdownToggle>
          <DropdownMenu className={this.state.showDrop ? 'show' : ''}>
            {this.props.choices.map((choice, id) => (
              <DropdownItem
                key={id}
                onClick={() => this.onChange(choice)}
              >
                {choice?.text ?? ''}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }
}

export default FilterUniverse
